import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { faCheck, Icon } from "@rivet-gg/icons";
import * as React from "react";
import { cn } from "../lib/utils";

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			"peer h-4 w-4 shrink-0 rounded-[4px] border transition-colors",
			"border-foreground/30 bg-transparent",
			"hover:border-foreground/50",
			"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background",
			"disabled:cursor-not-allowed disabled:opacity-50",
			"data-[state=checked]:bg-foreground data-[state=checked]:border-foreground data-[state=checked]:text-background",
			className,
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator
			className={cn("flex items-center justify-center text-current")}
		>
			<Icon icon={faCheck} className="h-2.5 w-2.5" />
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
